import React from "react";
import { Box, useTheme } from "@mui/material";
import { BRAND, DIM } from "../theme/index.js";

// Deterministic color per bot name — cycles through brand palette
const MARK_COLORS: Array<{ bg: string; text: string; border: string }> = [
  { bg: DIM.cyan,   text: BRAND.cyan,   border: BRAND.cyan   },
  { bg: DIM.yellow, text: "#B89A00",    border: BRAND.yellow },
  { bg: DIM.coral,  text: BRAND.coral,  border: BRAND.coral  },
  { bg: DIM.purple, text: BRAND.purple, border: BRAND.purple },
  { bg: DIM.green,  text: BRAND.green,  border: BRAND.green  },
];

function pickColor(name: string) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return MARK_COLORS[Math.abs(hash) % MARK_COLORS.length];
}

function initials(name: string): string {
  const words = name.trim().split(/\s+/);
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
}

interface BotLetterMarkProps {
  name: string;
  size?: number;
}

export function BotLetterMark({ name, size = 36 }: BotLetterMarkProps) {
  const theme = useTheme();
  const color = pickColor(name);
  const fontSize = Math.round(size * 0.38);

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: "6px",
        border: `1.5px solid ${color.border}`,
        backgroundColor: color.bg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        fontFamily: "'Outfit', sans-serif",
        fontSize,
        fontWeight: 600,
        color: color.text,
        letterSpacing: "-0.5px",
        userSelect: "none",
      }}
    >
      {initials(name)}
    </Box>
  );
}
